export const siteSettings = {
  name: "Smart Magnetic",
  link: "https://smartmagnetic.live",
  email: "support@smartmagnetic.live",
  appLink: "https://app.smartmagnetic.live",
};
